import '../../node_modules/normalize.css/normalize.css';

import 'bootstrap/dist/css/bootstrap.min.css';
import '@fontsource/inter';
import App from './App.svelte';

const app = new App({
  target: document.getElementById('app') as Element
})

export default app
